import * as types from './mutation-types'
export const loadData = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/auditor/dashboard`, { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

